/**
 *  @class
 *  @function Predictive Search
 */
const PREDICTIVE_SEARCH_QUERY_PARAMS = {
  'resources[type]': 'product,article,query,collection', // product, page, article, collection, query
  'resources[limit]': 10, // 1–10
  // 'resources[limit_scope]': 'all',                      // 'all' or 'each'
  // 'resources[options][unavailable_products]': 'last',   // 'show', 'hide', 'last'
  'resources[options][fields]': 'title,product_type,vendor,variants.title,variants.sku,variants.barcode',
};

if (!customElements.get('search-form')) {
  class SearchForm extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.form = this.querySelector('form');
      this.input = this.querySelector('input[type="search"]');
      this.select = this.querySelector('#header-search-select');
      this.predictiveSearchResults = this.querySelector('.thb-predictive-search');
      this.cc = this.querySelector('.searchform--click-capture');

      this.setupEventListeners();
    }
    setupEventListeners() {
      this.form.addEventListener('submit', this.onFormSubmit.bind(this));
      this.predictiveSearchResults.addEventListener('focusout', this.close.bind(this));

      this.input.addEventListener(
        'input',
        debounce((event) => {
          this.onChange(event);
        }, 300).bind(this)
      );

      this.cc.addEventListener('click', this.close.bind(this));

      document.addEventListener('click', (e) => {
        if (!this.contains(e.target)) {
          this.close();
        }
      });

      document.addEventListener('keyup', (e) => {
        if (e.code) {
          if (e.code.toUpperCase() === 'ESCAPE') {
            this.close();
          }
        }
      });
      this.input.addEventListener('focus', this.open.bind(this));

      if (this.select) {
        this.restoreSelectedProductType();
        this.select.addEventListener('change', () => {
          localStorage.setItem('SelectedProductType', this.select.value);
        });
      }
    }

    restoreSelectedProductType() {
      const saved = localStorage.getItem('SelectedProductType');
      if (saved === null) return;
      // Only restore if the saved value still matches one of the current options —
      // otherwise the merchant may have switched filter_search_by (product_type ↔ tag)
      // since it was stored.
      const hasOption = Array.from(this.select.options).some((opt) => opt.value === saved);
      if (hasOption) this.select.value = saved;
    }

    getQuery() {
      return this.input.value.trim();
    }

    onChange() {
      const searchTerm = this.getQuery();

      if (!searchTerm.length) {
        document.body.classList.remove('open-search');
        this.predictiveSearchResults.setAttribute('inert', '');
        return;
      }
      document.body.classList.add('open-search');
      this.predictiveSearchResults.removeAttribute('inert');
      this.getSearchResults(searchTerm);
    }

    onFormSubmit(event) {
      if (!this.getQuery().length) {
        event.preventDefault();
        return;
      }
      this.stripEmptySelects();
    }

    // Disable selects whose value is empty so the browser excludes them from form data.
    // Without this, "All" options with value="" produce trailing &filter.p.product_type= in the URL.
    stripEmptySelects() {
      this.form.querySelectorAll('select').forEach((sel) => {
        if (!sel.value) sel.disabled = true;
      });
    }

    onFocus() {
      const searchTerm = this.getQuery();

      if (!searchTerm.length) {
        return;
      }

      this.getSearchResults(searchTerm);
    }

    getSearchResults(searchTerm) {
      this.predictiveSearchResults.classList.add('loading');

      const params = new URLSearchParams({ q: searchTerm, ...PREDICTIVE_SEARCH_QUERY_PARAMS, section_id: 'predictive-search' });

      fetch(`${theme.routes.predictive_search_url}?${params}`)
        .then((response) => {
          this.predictiveSearchResults.classList.remove('loading');
          if (!response.ok) {
            var error = new Error(response.status);
            throw error;
          }

          return response.text();
        })
        .then((text) => {
          const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search').innerHTML;

          this.renderSearchResults(resultsMarkup);
        })
        .catch((error) => {
          throw error;
        });
    }

    renderSearchResults(resultsMarkup) {
      this.predictiveSearchResults.innerHTML = resultsMarkup;

      let submitButton = this.querySelector('#search-results-submit');

      submitButton.addEventListener('click', () => {
        // form.submit() doesn't fire the submit event, so clean params here too.
        this.stripEmptySelects();
        this.form.submit();
      });
    }

    close() {
      this.predictiveSearchResults.setAttribute('inert', '');
      document.body.classList.remove('open-search');
    }
    open() {
      document.body.classList.add('open-search');
      this.predictiveSearchResults.removeAttribute('inert');
    }
  }
  customElements.define('search-form', SearchForm);
}
